<template>
    <NuxtLayout name="default">

        <!-- Display categories -->
        <CategoryList :categories="categories" />

        <!-- Display reviews -->
        <ReviewList :reviews="reviews" :loadMore="loadMoreReviews" :loading="reviewLoading" :nextPage="reviewsPage" />

        <!-- Display suggested places -->
        <SuggestedPlaces :places="places" :loadMore="loadMorePlaces" :loading="placeLoading" :nextPage="placesPage"  />
    </NuxtLayout>
</template>

<script setup lang="ts">
    useHead({
        title: 'رفيو | المنصة الأولى في التقييم و معرفة تجارب الآخرين و الاستفادة منها',
        titleTemplate: ( titleChunk ) => {
            return titleChunk;
        },
        meta: [
        { property: 'og:title', content: `رفيو | المنصة الأولى في التقييم و معرفة تجارب الآخرين و الاستفادة منها` },
        { property: 'twitter:title', content: `رفيو | المنصة الأولى في التقييم و معرفة تجارب الآخرين و الاستفادة منها` },       
        ]
    })

    import {
        ref,
        onMounted
    } from "vue";
    import type {
        Rating,
        Place,
        PlaceCategory
    } from '~/types/types';

    // Access global API instance
    const {
        $api
    } = useNuxtApp();

    // Initialize repositories
    const ratingRepo = ratingsRepository($api);
    const placeRepo = placesRepository($api);
    const categoryRepo = categoriesRepository($api);

    // Reactive state variables
    const reviews = ref < Rating[] > ([]);
    const places = ref < Place[] > ([]);
    const categories = ref < PlaceCategory[] > ([]);
    const placeLoading = ref(true);
    const reviewLoading = ref(true);

    // Pagination tracking
    const reviewsPage = ref < number | null > (null);
    const placesPage = ref < number | null > (null);

    /**
     * Fetches reviews from the API with pagination.
     * @param {number} page - The page number to fetch.
     */
    const fetchReviews = async (page = 1) => {
        try {
            const {
                data: reviewsData,
                nextPage: reviewsNextPage
            } = await ratingRepo.getHome({
                page_count : 12,
                sort : 1
            }, page);

            // Append new reviews to the list
            reviews.value = [...reviews.value, ...reviewsData];
            reviewLoading.value = false
            

            // Update next page reference
            reviewsPage.value = reviewsNextPage;
        } catch (error) {
            console.error("Error fetching reviews:", error);
        }
    };

    /**
     * Fetches places from the API with pagination.
     * @param {number} page - The page number to fetch.
     */
    const fetchPlaces = async (page = 1) => {
        try {
            const {
                data: placesData,
                nextPage: placesNextPage
            } = await placeRepo.get({
                page_count : 8,
            }, page);
            if (page == 1) {
                console.log('placesData',placesData);
                
                places.value = placesData;
            }else{
                // Append new places to the list
                places.value = [...places.value, ...placesData];
            }
            placeLoading.value = false

            // Update next page reference
            placesPage.value = placesNextPage;
        } catch (error) {
            console.error("Error fetching places:", error);
        }
    };

    /**
     * Fetches initial data including categories, places, and reviews.
     */
    const fetchData = async () => {

        console.log('fetchData');
        
        try {
            
            // Fetch categories (assuming no pagination is needed)
            categories.value = await categoryRepo.get();

            // Fetch first page of places and reviews
            await fetchPlaces(1);
            await fetchReviews(1);
        } catch (error) {
            console.error("Error fetching initial data:", error);
        } finally {
            reviewLoading.value = false;
            placeLoading.value = false;
        }

        throw new Error("Nuxt Button Error");

    };

    /**
     * Loads more reviews if there are additional pages available.
     */
    const loadMoreReviews = async () => {
        reviewLoading.value = true
        if (reviewsPage.value) {
            await fetchReviews(reviewsPage.value);
        }
    };

    /**
     * Loads more places if there are additional pages available.
     */
    const loadMorePlaces = async () => {
        placeLoading.value = true
        if (placesPage.value) {
            await fetchPlaces(placesPage.value);
        }
    };

    // Fetch data when the component is mounted
    onMounted(fetchData);
    
    const nuxtApp = useNuxtApp()

    onMounted(() => {

        console.log('location:registered run');
        
        nuxtApp.$bus.on('location:registered', (user) => {
            reviewLoading.value = true
            placeLoading.value = true
            reviews.value = []
            places.value = []
            fetchData()
            console.log('New registration:', user)
        })
    })

    // Optionally clean up on unmount
    // onBeforeUnmount(() => {
    //     nuxtApp.$bus.off('location:registered')
    // })
</script>

<style scoped>
    .error {
        color: red;
    }
</style>
